import * as stylex from "@stylexjs/stylex";
import {
  colors,
  fonts,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";

export function BrowseTileFigures({
  counts,
}: {
  readonly counts:
    | { readonly players: number; readonly policies: number }
    | "loading"
    | "unpublished"
    | null;
}) {
  if (typeof counts === "string" || counts === null)
    return (
      <output {...stylex.props(styles.figures, styles.note)}>
        {counts === null
          ? "Counts unavailable"
          : { loading: "Loading counts…", unpublished: "No standings yet" }[
              counts
            ]}
      </output>
    );

  return (
    <span {...stylex.props(styles.figures)}>
      <span {...stylex.props(styles.tileFigure)}>
        <span {...stylex.props(styles.tileValue)}>
          {counts.players.toLocaleString()}
        </span>
        <span>{counts.players === 1 ? "player" : "players"}</span>
      </span>
      <span {...stylex.props(styles.tileFigure)}>
        <span {...stylex.props(styles.tileValue)}>
          {counts.policies.toLocaleString()}
        </span>
        <span>{counts.policies === 1 ? "policy" : "policies"}</span>
      </span>
    </span>
  );
}

const styles = stylex.create({
  note: {
    margin: 0,
    fontFamily: fonts.sans,
    fontSize: fontSizes.body,
    lineHeight: 1.6,
    color: colors.subtle,
  },
  figures: {
    display: "flex",
    alignItems: "baseline",
    gap: spacing.space20,
    height: spacing.space24,
  },
  tileFigure: {
    display: "flex",
    alignItems: "baseline",
    gap: spacing.space6,
    whiteSpace: "nowrap",
    fontFamily: fonts.sans,
    fontSize: fontSizes.label,
    color: colors.subtle,
  },
  tileValue: {
    fontSize: fontSizes.body,
    fontWeight: 500,
    color: colors.foreground,
    fontVariantNumeric: "tabular-nums",
  },
});
